import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RejectBankProofDocumentState, rejectBankProofDocumentFeatureKey } from '../reducers/reject-bankproof-document.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as approvedState from '../reducers/reject-bankproof-document.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, RejectBankProofDocumentState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee Approve SUB STATE
export const getApprovedState = createSelector(getMainEmployeeState, state => state[rejectBankProofDocumentFeatureKey]);
//#endregion

//#region Employee Approve docs SUB STATE
export const selectRejectBankProofDocumentRequest = createSelector(getApprovedState, approvedState.getRejectBankProofDocumentRequest);
export const selectRejectBankProofDocumentSuccess = createSelector(getApprovedState, approvedState.getRejectBankProofDocumentResponse);
export const selectRejectBankProofDocumentFailure = createSelector(getApprovedState, approvedState.getRejectBankProofDocumentFailure);
//#endregion
